import { Component, OnInit, ComponentRef } from '@angular/core';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';

import { MODALIDADES } from '../../_mocks/modalidades';
import { COMISSOES } from '../../_mocks/comissoes';
import { ORGAOS } from '../../_mocks/orgaos';
import { TIPO_DE_DOCUMENTOS } from '../../_mocks/tipoDeDocumentos';
import { FASES_DA_LICITACAO } from '../../_mocks/fasesDaLicitacao';
import { TIPOS_DE_OBJETO_DA_LICITACAO } from '../../_mocks/tiposDeObjetoDaLicitacao';

import { Licitacao } from '../../_classes/licitacao';

import { LicitacaoService } from '../../services/licitacao.service';
import { Base64Service } from '../../services/base64.service';
import { Arquivo } from '../../_classes/arquivo';
import { LoadingService } from '../../services/loading.service';
import { NgControl, FormControl, FormGroup, NgForm } from '@angular/forms';
import { LoadingFileService } from '../../services/loading-file.service';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog } from '@angular/material';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';


import 'rxjs/add/operator/catch';
import { DomService } from '../../services/dom-service.service';
import { ContratoInfoComponent } from '../contrato-info/contrato-info.component';

@Component({
  selector: 'app-licitacoes',
  templateUrl: './licitacoes.component.html',
  styleUrls: ['./licitacoes.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class LicitacoesComponent implements OnInit {

  tipoDeDocumento = '';
  required: boolean;
  arquivos: Arquivo[];
  public maskLicitacao = [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskData = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public mascaraCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,];
  public numberMask = createNumberMask({
    prefix: 'R$ ',
    thousandsSeparatorSymbol: '.',
    decimalSymbol: ',',
    decimalLimit: 2,
    allowDecimal: true,
    suffix: ''
  });
  fileInput = null;
  file: File = null;
  licitacao: Licitacao;
  modalidades = MODALIDADES;
  comissoes = COMISSOES;
  orgaos = ORGAOS;
  tipoDeDocumentos = TIPO_DE_DOCUMENTOS;
  fasesDaLicitacao = FASES_DA_LICITACAO;
  tiposDeObjetoDaLicitacao = TIPOS_DE_OBJETO_DA_LICITACAO;
  teste = '';
  dialogResult = '';

  constructor(
    private adapter: DateAdapter<any>,
    private licitacaoService: LicitacaoService,
    private base64: Base64Service,
    private loadingService: LoadingService,
    private loadingFileService: LoadingFileService,
    public dialog: MatDialog,
    private domService: DomService
  ) { }

  ngOnInit() {
    this.initLicitacao();
    this.required = true;
    // const temp: Arquivo = new Arquivo();
    // temp.nome = 'blabla'
    // const contratoRef: ComponentRef<ContratoInfoComponent> = this.domService.appendComponentToBody(ContratoInfoComponent)
    // contratoRef.instance.contrato = temp
    // contratoRef.instance.selfReference = contratoRef
  }

  initLicitacao() {
    this.licitacao = new Licitacao();
    this.arquivos = [];
    this.licitacao.comissao = JSON.parse(localStorage.getItem("user")).comissao;
  }

  handleFileInput(files: FileList, inputFile: FormControl) {
    this.file = files.item(0);
    if (this.file !== undefined && this.file !== null) {
      this.createArquivo(this.file);
      this.file = null;
      inputFile = new FormControl();
      this.tipoDeDocumento = '';
    }
  }

  createArquivo(file: File) {
    const a = new Arquivo();
    a.nome = file.name;
    a.tamanho = this.getSize(file.size);
    a.tipoDeDocumento = this.tipoDeDocumento;

    const fileName = file.name
    let extensaoSplit = fileName.split('.');
    let extensao = extensaoSplit[extensaoSplit.length - 1];

    a.extensao = extensao;

    this.base64.convert(file, function (result) {
      a.valor = result;
    });
    this.addFile(a);
  }

  addFile(file: Arquivo) {
    if (this.verifyFileIsAdd(file)) {
      alert('Arquivo já adicionado');
    } else if (this.verifySize(file)) {
      alert('Arquivo excede 30 Mb');
    } else {
      this.arquivos.push(file);
    }
  }

  updateComissao() {
    this.licitacao.comissao = JSON.parse(localStorage.getItem("user")).comissao;
  }

  private verifySize(file) {
    if (file.tamanho.indexOf('MB') > -1) {
      return file.tamanho.replace(' MB', '') > 30;
    }
    return false;
  }

  private verifyFileIsAdd(file: Arquivo) {
    let result = false;
    if (this.arquivos.length > 0) {
      this.arquivos.forEach(f => {
        if (file.nome === f.nome) {
          result = true;
          return;
        }
      });
    }

    return result;
  }

  removeFile(file) {
    this.arquivos.splice(this.arquivos.indexOf(file), 1);
  }

  getSize(size: number) {
    size = size / 1000;
    if (999 > size) {
      return size.toFixed(3) + ' Kb';
    }
    size = size / 1000;
    return size.toFixed(3) + ' MB';
  }

  validateFiles() {
    return this.arquivos.length > 0;
  }

  validateNumeroLicitacao() {
    return this.licitacao.numeroDaLicitacao && this.licitacao.numeroDaLicitacao.indexOf('_') < 0;
  }

  openDialog() {
    let dialogRef = this.dialog.open(DialogComponent, {
      width: '300px',
      data: 'Licitação já registrada.'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed: ' + result);
      this.dialogResult = result;
    });
  }

  submitLicitacao(formLicitacao: NgForm, evento: Event) {
    event.preventDefault();

    this.loadingService.changeLoading(true);
    this.licitacaoService.saveLicitacao(this.licitacao).subscribe(response => {
      const id = response.id;
      this.arquivos.forEach(form => {
        this.loadingFileService.changeLoading(true);
        this.licitacaoService.uploadFile(id, form).subscribe(result => {
          this.loadingFileService.changeLoading(false);
        });
      });
      // err => console.log(err);
      // this.loadingFileService.changeLoading(false);
      this.loadingService.changeLoading(false);
      this.arquivos = [];
      this.fileInput = '';
      formLicitacao.resetForm();
      this.initLicitacao();
    }, error => {
      alert('erro')
      console.log('erro', error);

      this.openDialog();
      this.loadingService.changeLoading(false);
      this.arquivos = [];
      this.fileInput = '';
      formLicitacao.resetForm();
      this.initLicitacao();
    });
  }

  acaoDocumentoPersonalizado(arquivo: Arquivo) {
    const tipoDocumento = arquivo.tipoDeDocumento

    const contratoRef: ComponentRef<ContratoInfoComponent> = this.domService.appendComponentToBody(ContratoInfoComponent)
    contratoRef.instance.contrato = arquivo
    contratoRef.instance.selfReference = contratoRef
  }

}



// WEBPACK FOOTER //
// ./src/app/components/licitacoes/licitacoes.component.ts